import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the TwoNumPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'twoNum',
})
export class TwoNumPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return (value + "").length < 2 ? "0" + value : value;
  }
}



// WEBPACK FOOTER //
// /src/pipes/two-num/two-num.ts